module.exports = __webpack_public_path__ + "static/media/descarga.1b210136.svg";